export const showBackArrow = () => {
  const backArrow = document.querySelector('.cce-widget__window__header--back')
  backArrow.classList.remove(`cce-widget__window__header--back-hide`)
}
